import map from 'lodash/map';

export function extractTripData({ last_campaigns = [] }) {
  const sorted = last_campaigns.sort((a, b) => {
    return b.year - a.year || b.month - a.month;
  });

  return map(sorted, (item) => ({
    city: item.market_name,
    date: item.release_date,
    networkCode: item.network_code,
    marketImagePath: item.market_image_path,
    marketPresentationPath: item.market_presentation_path,
    nbRestaurants: item.dn_client,
    toRedirectDistribution: {
      market: item.market_name,
      network_code: item.network_code
    },
    link: getLinkDistribution(item.network_code),
    subscribed: item.subscribed
  }));
}

function getLinkDistribution(networkCode) {
  const linkMap = {
    ON: '/distribution/restaurants',
    OFF: '/distribution/restaurants'
  };
  return linkMap[networkCode] || null;
}
